<template>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px"
 viewBox="0 0 16 16" xml:space="preserve">
  <path fill="currentColor" class="st0" d="M1,6h14c0.6,0,1,0.4,1,1v2c0,0.6-0.4,1-1,1H1c-0.6,0-1-0.4-1-1V7C0,6.4,0.4,6,1,6z M1,12h14c0.6,0,1,0.4,1,1v2
c0,0.6-0.4,1-1,1H1c-0.6,0-1-0.4-1-1v-2C0,12.4,0.4,12,1,12z M1,0h14c0.6,0,1,0.4,1,1v2c0,0.6-0.4,1-1,1H1C0.4,4,0,3.6,0,3V1
C0,0.4,0.4,0,1,0z"/>
</svg>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/IconBars.vue